import { Box, LinearProgress, Skeleton, Stack, SxProps } from "@mui/material";
import { Theme } from "klayowebshared";
import { Component } from "react";
import { Utils } from "../common/Utils";
import { AttributeProgressBarLabel } from "./AttributeProgressBarLabel";
import { Tooltip } from "./Tooltip";

interface AttributeProgressBarProps {
  sx?: SxProps;
  met?: number | null;
  total?: number | null;
  showLabel?: boolean;
  color?: string;
  label?: string;
  barHeight?: number;
  gapBarHeight?: number;
  onClick?: () => void;
  singleRow?: boolean;
  showFraction?: boolean;
  showPercent?: boolean;
  loading?: boolean;
  progressBarProps?: any;
}

export class AttributeProgressBar extends Component<AttributeProgressBarProps> {
  static defaultProps = {
    showLabel: true,
    barHeight: 18,
    gapBarHeight: 18,
    singleRow: false,
    color: Theme.getStyleVar("--neon-blue-nb-300"),
    showFraction: true,
    showPercent: true
  };

  static calculatePercent(met: number, total: number) {
    return total !== 0 ? (met / total) * 100 : 0;
  }

  render() {
    const {
      sx,
      met,
      total,
      showLabel,
      color,
      label,
      barHeight,
      gapBarHeight,
      onClick,
      singleRow,
      showFraction,
      showPercent,
      loading
    } = this.props;
    const percent = AttributeProgressBar.calculatePercent(met || 0, total || 0);

    const styles = {
      height: barHeight,
      borderRadius: (barHeight || 0) / 2,
      backgroundColor: Theme.getStyleVar("--grey-gr-100"),
      width: "100%"
    };

    return (
      <Box
        className={"klaro_attr-progress" + (singleRow ? " klaro_attr-progress_singlerow" : "")}
        sx={{ width: "100%", ...sx }}
      >
        <Stack
          direction={singleRow ? "row" : "column"}
          justifyContent='space-between'
          alignItems='center'
        >
          {showLabel && <AttributeProgressBarLabel {...this.props} />}
          {loading ? (
            <Skeleton width='100%' height={barHeight} variant='rounded' />
          ) : (
            <Tooltip
              title={
                label +
                ": " +
                (percent !== null && total !== 0
                  ? met + "/" + total + " (" + Utils.formatPercent(percent) + ")"
                  : "n/a")
              }
            >
              <LinearProgress
                sx={{
                  ...styles,
                  width: "100%",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: color,
                    borderRadius: styles.borderRadius,
                    left: percent ? 0 : -1
                  },
                  cursor: onClick ? "pointer" : "default"
                }}
                variant='determinate'
                value={loading ? -10 : percent}
                onClick={onClick}
              />
            </Tooltip>
          )}
        </Stack>
      </Box>
    );
  }
}
